module.exports = __webpack_public_path__ + "static/sys_ph10-67fef3be743c49c56b47dc46e18666f3.jpg";